// Preis-Slider auf der Partner-Seite
class PriceSlider {
    constructor(rangeInput) {
        const parent = rangeInput.parentNode.parentNode;

        this.countElement = parent.querySelector('.js-priceslider-count');
        this.provisionElement = parent.querySelector('.js-priceslider-provision');
        this.monthlypriceElement = parent.querySelector('.js-priceslider-monthlyprice');
        this.updateOutput = this.updateOutput.bind(this);

        // Initiales Befüllen der Ausgaben
        this.updateOutput(rangeInput.value);

        // Event auf Slider legen
        rangeInput.addEventListener('change', (event) => {
            this.updateOutput(event.target.value);
        });
    }

    updateOutput(currentValue) {
        this.countElement.textContent = currentValue;
        this.provisionElement.textContent = 0;
        this.monthlypriceElement.textContent = currentValue * 10;
    }
}

const priceSlider = {
    init() {
        const priceSliderInput = document.querySelectorAll('.js-priceslider');

        if (priceSliderInput) {
            priceSliderInput.forEach((rangeInput) => {
                // eslint-disable-next-line no-new
                new PriceSlider(rangeInput);
            });
        }
    },
};

export default priceSlider;
